import { render, staticRenderFns } from "./createSkuOrder.vue?vue&type=template&id=1b0ae8f5&scoped=true"
import script from "./createSkuOrder.vue?vue&type=script&lang=js"
export * from "./createSkuOrder.vue?vue&type=script&lang=js"
import style0 from "./createSkuOrder.vue?vue&type=style&index=0&id=1b0ae8f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ae8f5",
  null
  
)

export default component.exports